// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rC6YWcFr","shouldUseBorderOnFallback":"vFDSf2B_"};